import { render, staticRenderFns } from "./Version4.vue?vue&type=template&id=e3b0f492&"
import script from "./Version4.vue?vue&type=script&lang=js&"
export * from "./Version4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports